export const model = {
    id: null,
    name:"",
    total_price: "",
    order_count: "",
    created_at: '',
    updated_at: ''
};